/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import { NON_LHI_SOURCES, IFI_PHONE_NUMBER, SPIG_PHONE_NUMBER } from 'config/constants';
import S from '../styles.scss';

const FollowUpCallScript = (props) => {
  const { title, customerAnswered, jobNotFinished, customerUnsatisfied, handleBasicQuestion, source, phaseType } = props;
  const didAnswer = customerAnswered === 'yes';
  const lhiPhase = !NON_LHI_SOURCES.includes(source);
  const ifiPhase = source === 'IFI';
  const jobWord = phaseType === 'Installation' ? 'installation' : 'repair';
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>{`${title} ${didAnswer ? 'Answered' : 'Voicemail'}`} Script</h4>
    </div>
    <Fragment>
      {ifiPhase ? (<Fragment>
        {didAnswer ? (<div className={S.scriptContainer}>
          <p>Positive: Great! That is what we love to hear, I wanted to let you know if you have any questions or concerns with your {jobWord}, please don&apos;t hesitate to reach out because you do have that 1-year warranty. Also, I wanted to let you know Lowe&apos;s will be sending an email out with a survey on the installer&apos;s craftmanship, professionalism, and your likelihood to recommend us to friends and family. This survey is very important to our installers as only 10&apos;s are passing scores.</p>
          <br />
          <p>Was there any part of your {jobWord} that would prevent you from rating your overall experience a 10?</p>
          <br />
          <Button
            label="YES"
            flat inverse ripple
            disabled={customerUnsatisfied === 'yes'}
            className={S.standardButton}
            onClick={() => handleBasicQuestion('customerUnsatisfied', 'yes')}
          />
          <Button
            label="NO"
            flat inverse ripple
            disabled={customerUnsatisfied === 'no'}
            className={S.standardButton}
            onClick={() => handleBasicQuestion('customerUnsatisfied', 'no')}
          />
          {customerUnsatisfied && <ContainerDiv>
            <DropdownDiv condition={customerUnsatisfied}>
              <br />
              {customerUnsatisfied === 'no' ? (<p>
                Perfect! Again, if you need anything please give us a call at {IFI_PHONE_NUMBER}. Thank you and have a great day!
              </p>) : (<Fragment>
                <p>Ok, what were the issues you experienced? (Wait for reply)</p>
                <br />
                <p>If it is something installer side that we need to get the installer back out to: Ok, I understand, I will get what we call a work order opened so we can get those issues fixed. We will reach out to Lowe&apos;s to get this created and you should hear something back within 48 hours.</p>
                <br />
                <p>If it is something on the store side: Ok, on the survey there will be a section where you can leave a comment. This is where you can put your issues you experienced and this will go straight to the store. If you ever need anything please give us a call back at {IFI_PHONE_NUMBER}. Thank you and have a great day.</p>
              </Fragment>)}
            </DropdownDiv>
          </ContainerDiv>}
        </div>) : (<div className={S.scriptContainer}>
          <p>
            I wanted to confirm that everything has been completed and you are happy with your {jobWord}.
          </p>
          <br />
          <p>
            Lowe&apos;s will be reaching out via text or email to complete a survey.
            They will ask about our craftmanship, professionalism, and your likelihood to recommend Lowe&apos;s and Integrity First to family or friends.
            The survey is very important to our installers and only 10s are passing scores.
            If for any reason you are not completely satisfied with your {jobWord}, please reach out so we can assist with a resolution.
          </p>
          <br />
          <p>
            Also, as a reminder you have a 1-year labor warranty.
            If you have any concerns with your {jobWord} during that time frame, please call {IFI_PHONE_NUMBER}.
          </p>
          <br />
          <p>Thank you and have a great day!</p>
        </div>)}
      </Fragment>) : (<Fragment>
        {didAnswer ? (<Fragment>
          <div className={S.scriptContainer}>
            <p className={S.scriptUserNote}>USER NOTE: Did the customer say the job was NOT completed?</p>
            <br />
            <Button
              label="YES"
              flat inverse ripple
              disabled={jobNotFinished === 'yes'}
              className={S.standardButton}
              onClick={() => handleBasicQuestion('jobNotFinished', 'yes')}
            />
            <Button
              label="NO"
              flat inverse ripple
              disabled={jobNotFinished === 'no'}
              className={S.standardButton}
              onClick={() => handleBasicQuestion('jobNotFinished', 'no')}
            />
          </div>
          {jobNotFinished && <ContainerDiv>
            <DropdownDiv condition={jobNotFinished}>
              <div className={S.scriptContainer}>
                {jobNotFinished === 'yes' ? (<Fragment>
                  <p>
                    I{'\''}m so sorry to hear that.
                    I am going to connect with the installer to gather more information and we will call you back with a resolution.
                  </p>
                  <br />
                  <p className={S.scriptUserNote}>USER NOTE: Pause and allow the customer to respond.</p>
                  <br />
                  <p>
                    Again, we are very sorry this has happened. Thank you for your patience and I hope you have a great day.
                  </p>
                </Fragment>) : (<Fragment>
                  {lhiPhase && <Fragment>
                    <p>
                      Lowe{'\''}s will be reaching out via text or email to complete a survey.
                      They will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe{'\''}s and Service Pros to family or friends.
                      The survey is very important to us, and only 10s are passing scores.
                    </p>
                    <br />
                  </Fragment>}
                  <p>Was there any part of your project that would prevent you from rating your experience a 10?</p>
                  <br />
                  <Button
                    label="YES"
                    flat inverse ripple
                    disabled={customerUnsatisfied === 'yes'}
                    className={S.standardButton}
                    onClick={() => handleBasicQuestion('customerUnsatisfied', 'yes')}
                  />
                  <Button
                    label="NO"
                    flat inverse ripple
                    disabled={customerUnsatisfied === 'no'}
                    className={S.standardButton}
                    onClick={() => handleBasicQuestion('customerUnsatisfied', 'no')}
                  />
                  {customerUnsatisfied && <ContainerDiv>
                    <DropdownDiv condition={customerUnsatisfied}>
                      <br />
                      {customerUnsatisfied === 'yes' ? (<p className={S.scriptUserNote}>
                        Identify and address the concern and explain the next steps for resolution.
                      </p>) : (<p>Perfect! I{'\''}m happy to hear that.</p>)}
                      <br />
                      <p>
                        Also, as a reminder you have a 1-year labor warranty.
                        If you have any concerns with your {jobWord} during that time frame, please call and let us know.
                      </p>
                      <br />
                      <p>Thank you and have a great day!</p>
                    </DropdownDiv>
                  </ContainerDiv>}
                </Fragment>)}
              </div>
            </DropdownDiv>
          </ContainerDiv>}
        </Fragment>) : (<div className={S.scriptContainer}>
          <p>
            I wanted to confirm that everything has been completed and you are happy with your {jobWord}.
          </p>
          <br />
          <p>
            {lhiPhase && <span>
              Lowe{'\''}s will be reaching out via text or email to complete a survey.
              They will ask about our craftsmanship, professionalism, and your likelihood to recommend to family or friends.
              The survey is very important to our installers and only 10s are passing scores.
            </span>}
            If for any reason you are not completely satisfied with your {jobWord}, please reach out so we can assist with a resolution.
          </p>
          <br />
          <p>
            Also, as a reminder you have a 1-year labor warranty.
            If you have any concerns with your {jobWord} during that time frame, please call {SPIG_PHONE_NUMBER}.
          </p>
          <br />
          <p>Thank you and have a great day!</p>
        </div>)}
      </Fragment>)}
    </Fragment>
  </Card>);
};

FollowUpCallScript.propTypes = {
  title: PropTypes.string,
  customerAnswered: PropTypes.string,
  jobNotFinished: PropTypes.string,
  customerUnsatisfied: PropTypes.string,
  handleBasicQuestion: PropTypes.func,
  source: PropTypes.string,
  phaseType: PropTypes.string,
};

export default FollowUpCallScript;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/followUpCallScript.jsx